import { render, staticRenderFns } from "./IconCircle.vue?vue&type=template&id=04e4189c"
import script from "./IconCircle.vue?vue&type=script&lang=ts"
export * from "./IconCircle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports